// import React from "react";
// import Navbar from "../../Components/Navbar";
// import Header from "../../Components/Header";
// import { Container, Typography } from "@mui/material";
// import Footer from "../../Components/Footer";
// import CallToEnroll from "../../Components/CallToEnroll";
// import PageTitle from "../../Components/PageTitle";
// import SainikBanner from "../../assets/Sainik.png";

// const Sainik = () => {
//   return (
//     <>
//       <Navbar />
//       <PageTitle
//         title="Sainik School Coaching - Shree Mangalam School"
//         description="Get expert Sainik School entrance exam coaching at Shree Mangalam School. We offer structured study plans, experienced faculty, and mock tests to ensure success."
//         url="/sainik"
//         keywords="Sainik School coaching, AISSEE preparation, Sainik entrance exam, best sainik coaching, Shree Manglam Sainik School classes"
//       />

//       <Header image={SainikBanner} alt={"Sainik School Coaching Banner"} />

//       <Container sx={{ mb: 5, mt: 5 }}>
//         <Typography
//           variant="h5"
//           sx={{
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             fontSize: "30px",
//             letterSpacing: 1,
//             color: "#065A79",
//             fontWeight: "bold",
//           }}
//           gutterBottom
//         >
//           All India Sainik School Entrance Exam
//         </Typography>
//         <Typography
//           variant="body1"
//           sx={{
//             mt: 3,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           At Shree Mangalam School, we provide focused coaching
//           for the Sainik School Entrance Examination, empowering students to
//           pursue a disciplined, purpose-driven future in the defense services.
//           Our Sainik School preparation program is designed to guide young
//           aspirants from jaipur-gudha state highway (Just on by pass) gudha gorji, and surrounding areas through a
//           well-structured curriculum aligned with the AISSEE (All India Sainik
//           School Entrance Exam) format.
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mt: 2,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           The coaching includes comprehensive coverage of Mathematics, Language,
//           Intelligence, and General Knowledge, along with regular tests,
//           performance analysis, and motivational mentoring. Our dedicated team
//           ensures that every student is trained not only to clear the exam but
//           also to excel in the interview and medical rounds that follow. We also
//           provide full support in form filling, document verification, and exam
//           strategies.
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mt: 2,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           More than just academic preparation, our program builds discipline,
//           time management, confidence, and leadership — the very qualities that
//           Sainik Schools value. With consistent results and growing success
//           stories, Shree Mangalam School is proud to be a launchpad for
//           students aspiring to join the defense forces through Sainik Schools.
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mt: 2,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           Give your child the edge they deserve. Enroll in our All India Sainik
//           School Entrance Exam and become part of a growing success story at
//           Shree Mangalam School.
//         </Typography>
//       </Container>
//       <CallToEnroll />
//       <Footer />
//     </>
//   );
// };

// export default Sainik;

import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { 
  Container, 
  Typography, 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper
} from "@mui/material";
import Footer from "../../Components/Footer";
import CallToEnroll from "../../Components/CallToEnroll";
import PageTitle from "../../Components/PageTitle";
import SainikBanner from "../../assets/Sainik.png";

const Sainik = () => {
  const eligibilityCriteria = [
    { 
      parameter: "Age for Class 6", 
      details: "10–12 years as on 31st March of the admission year (as per AISSEE notification)",
      note: "For Class 6 admission"
    },
    { 
      parameter: "Age for Class 9", 
      details: "13-15 years as on 31st March of admission year",
      note: "For Class 9 admission"
    },
    { 
      parameter: "Educational Qualification", 
      details: "Passed Class 5 for Class 6, Class 8 for Class 9",
      note: "From recognized school"
    },
    { 
      parameter: "Nationality", 
      details: "Indian citizens only",
      note: "Valid proof required"
    },
    { 
      parameter: "Medical Fitness", 
      details: "Must meet prescribed medical standards",
      note: "Height, Weight, Eyesight"
    },
    { 
      parameter: "Exam Pattern", 
      details: "Maths, Language, Intelligence, GK (AISSEE)",
      note: "Written test + Interview"
    },
  ];

  return (
    <>
      <Navbar />
      <PageTitle
        title="Sainik School Coaching - Shree Mangalam School"
        description="Get expert Sainik School entrance exam coaching at Shree Mangalam School. We offer structured study plans, experienced faculty, and mock tests to ensure success."
        url="/sainik"
        keywords="Sainik School coaching, AISSEE preparation, Sainik entrance exam, best sainik coaching, Shree Manglam Sainik School classes"
      />

      <Header image={SainikBanner} alt={"Sainik School Coaching Banner"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          All India Sainik School Entrance Exam
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we provide focused coaching
          for the Sainik School Entrance Examination, empowering students to
          pursue a disciplined, purpose-driven future in the defense services.
          Our Sainik School preparation program is designed to guide young
          aspirants from jaipur-gudha state highway (Just on by pass) gudha gorji, and surrounding areas through a
          well-structured curriculum aligned with the AISSEE (All India Sainik
          School Entrance Exam) format.
        </Typography>

        {/* Eligibility Criteria Section */}
        <Box sx={{ mt: 6, mb: 4 }}>
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              fontSize: "26px",
              letterSpacing: 1,
              color: "#AD1C86",
              fontWeight: "bold",
              mb: 3,
            }}
          >
            Sainik School (AISSEE) Eligibility Criteria
          </Typography>
          
          {/* Responsive Table */}
          <Box sx={{ width: '100%', overflowX: "auto" }}>
            <TableContainer 
              component={Paper} 
              sx={{ 
                borderRadius: 2,
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                mb: 3,
                minWidth: 300
              }}
            >
              <Table sx={{ 
                minWidth: 300,
                '& th, & td': {
                  padding: { xs: '12px 8px', sm: '16px' }
                }
              }}>
                <TableHead>
                  <TableRow sx={{ bgcolor: '#065A79' }}>
                    <TableCell 
                      sx={{ 
                        color: 'white', 
                        fontWeight: 'bold',
                        fontSize: { xs: '14px', sm: '16px' },
                        fontFamily: 'Montserrat, sans-serif',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Parameter
                    </TableCell>
                    <TableCell 
                      sx={{ 
                        color: 'white', 
                        fontWeight: 'bold',
                        fontSize: { xs: '14px', sm: '16px' },
                        fontFamily: 'Montserrat, sans-serif'
                      }}
                    >
                      Details
                    </TableCell>
                    <TableCell 
                      sx={{ 
                        color: 'white', 
                        fontWeight: 'bold',
                        fontSize: { xs: '14px', sm: '16px' },
                        fontFamily: 'Montserrat, sans-serif'
                      }}
                    >
                      Note
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {eligibilityCriteria.map((row, index) => (
                    <TableRow 
                      key={index}
                      sx={{ 
                        '&:nth-of-type(odd)': { bgcolor: '#F8F9FA' },
                        '&:hover': { bgcolor: '#F0F7FF' }
                      }}
                    >
                      <TableCell 
                        component="th" 
                        scope="row"
                        sx={{ 
                          fontWeight: 'bold',
                          fontFamily: 'Montserrat, sans-serif',
                          color: '#065A79',
                          whiteSpace: 'nowrap',
                          fontSize: { xs: '13px', sm: 'inherit' }
                        }}
                      >
                        {row.parameter}
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          fontFamily: 'Montserrat, sans-serif',
                          lineHeight: '1.6',
                          fontSize: { xs: '13px', sm: 'inherit' }
                        }}
                      >
                        {row.details}
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          fontFamily: 'Montserrat, sans-serif',
                          fontSize: { xs: '13px', sm: 'inherit' },
                          color: '#666'
                        }}
                      >
                        {row.note}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box sx={{ mt: 3 }}>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1,
                bgcolor: '#F8F9FA',
                borderLeft: '4px solid #AD1C86'
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 0.5,
                  lineHeight: "1.6rem",
                  color: "#555",
                  fontSize: { xs: '13px', sm: 'inherit' }
                }}
              >
                <strong>Important:</strong> Age relaxation of up to 2 years is available for SC/ST candidates. 
                The All India Sainik School Entrance Exam (AISSEE) is conducted in January every year. 
                There are 33 Sainik Schools across India, each with state-specific reservation quotas.
              </Typography>
            </Paper>
          </Box>
        </Box>

        <Typography
          variant="body1"
          sx={{
            mt: 4,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          The coaching includes comprehensive coverage of Mathematics, Language,
          Intelligence, and General Knowledge, along with regular tests,
          performance analysis, and motivational mentoring. Our dedicated team
          ensures that every student is trained not only to clear the exam but
          also to excel in the interview and medical rounds that follow. We also
          provide full support in form filling, document verification, and exam
          strategies.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          More than just academic preparation, our program builds discipline,
          time management, confidence, and leadership — the very qualities that
          Sainik Schools value. With consistent results and growing success
          stories, Shree Mangalam School is proud to be a launchpad for
          students aspiring to join the defense forces through Sainik Schools.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Give your child the edge they deserve. Enroll in our All India Sainik
          School Entrance Exam and become part of a growing success story at
          Shree Mangalam School.
        </Typography>
      </Container>
      <CallToEnroll />
      <Footer />
    </>
  );
};

export default Sainik;